import type EnType from '../en-US/http';

export default {
  'httpRequestResult.response': 'Response',
  'httpRequestResult.noResponseDesc': '「送信」ボタンをクリックして、結果を取得してください。',
} satisfies typeof EnType;
